export const WRONG_URL_INPUT = "We couldn't find this url.";
export const SEARCH_WITH_WRONG_URL = "Incorrect search input specified. Please contact the administrator.";
